// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1_Bga","cls2":"PostEngagementFollowPrompt-cls2_srP PostEngagementFollowPrompt-cls1_Bga"};